"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStreamEvmOperation = void 0;
var dataTypes_1 = require("../../dataTypes");
exports.getStreamEvmOperation = {
    method: 'GET',
    name: 'getStreamEvm',
    id: 'GetStream',
    groupName: 'evmStreams',
    urlPathPattern: '/streams/evm/{id}',
    urlPathParamNames: ['id'],
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        id: request.id,
    };
}
function deserializeResponse(jsonResponse, request, core) {
    return dataTypes_1.EvmStream.create(jsonResponse, core);
}
function serializeRequest(request) {
    return {
        id: request.id,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        id: jsonRequest.id,
    };
}
//# sourceMappingURL=getStreamEvmOperation.js.map